import { Prefix } from "../config/const";

/**
 * 検索文字と一致する数を返却する
 * 
 * @param target 検索対象
 * @param searchStr 検索文字
 * @returns 
 */
export const getMatchCount = (target: string|undefined, searchStr: string): number => {
    // 検索対象がundefinedの場合は0を返却
    if (target === undefined) return 0;

    const result = target.match(new RegExp(searchStr, 'g'));
    return result === null ? 0 : result.length;
};

/**
 * 指定文字を繰り返した結果を返却する
 * 
 * @param value 指定文字
 * @param repeatCount 繰り返し回数
 * @returns 
 */
export const getRepeatString = (value: string, repeatCount: number): string => {
    let retValue = "";
    for (let i = 0; i < repeatCount; i++) {
        retValue += value
    }
    return retValue;
};

/**
 * 取込エラーファイルの先頭文字列を返却する
 * 
 * @param fileName 取込ファイル名
 * @returns 
 */
export const getImportErrorFileNamePrefix = (fileName: string | undefined): string => {
    // 入力ファイル名から取込エラーの数を取得
    const errCount = getMatchCount(fileName, Prefix.XLSX_IMPORT_ERROR);
    // 入力ファイルの取込エラー数 + 1 分、取込エラー文言を追加し返却
    return getRepeatString(Prefix.XLSX_IMPORT_ERROR, errCount + 1);
};

/**
 * 無効日付かどうかを返却する
 * 
 * @param date 
 * @returns true：無効 / false：有効
 */
export const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());

/**
 * 文字列を日付型に変換する
 * 
 * @param dateString 
 * @returns 
 */
export const stringToDate = (dateString: string): Date | undefined => {
    const date = new Date(dateString);
    return isInvalidDate(date) ? undefined : date;
};

/**
 * 年月日を比較する
 * 
 * @param date1 
 * @param date2 
 * @returns -1：date1 > date2 / 0：date1 = date2 / 1：date1 < date2 / undefined：無効日付
 */
export const compareDateOnlyYmd = (date1: Date | undefined, date2: Date | undefined): number | undefined => {
    if (date1 === undefined || isInvalidDate(date1) || date2 === undefined || isInvalidDate(date2)) return undefined;

    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    let retValue = 0;
    if (d1 < d2) {
        retValue = 1;
    } else if (d1 > d2) {
        retValue = -1;
    }

    return retValue;    
};

/**
 * 時分秒を比較する
 * 
 * @param date1 
 * @param date2 
 * @returns -0：date1 > date2 / 0：date1 = date2 / 1：date1 < date2 / undefined：無効日付
 */
export const compareDateOnlyTime = (date1: Date | undefined, date2: Date | undefined): number | undefined => {
    if (date1 === undefined || date2 === undefined) return undefined;

    const d1 = new Date(2000, 1, 1, date1.getHours(), date1.getMinutes(), date1.getSeconds(), date1.getMilliseconds());
    const d2 = new Date(2000, 1, 1, date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds());

    let retValue = 0;
    if (d1 < d2) {
        retValue = 1;
    } else if (d1 > d2) {
        retValue = -1;
    }

    return retValue;
};

/**
 * ランダムな数値を生成する
 * 
 * @param length 桁数
 * @returns ランダム数値文字列
 */
export const generateRandomDigits = (length: number = 8): string => {
    return Array.from({ length }, () => Math.floor(Math.random() * 10)).join('');
};

/**
 * 空文字かどうかを返却する
 * @param value 
 * @returns true：値なし / false：値あり
 */
export const isEmptyString = (value: string | undefined) : boolean => {
    return (value === null || value === undefined || value === '');
}

/**
 * 日付から9時間マイナスする
 * 
 * @param date
 * @returns date / undefined
 */
export const nineHourMinusDate = (date: Date | undefined) => {
    if(date){
        date.setHours(date.getHours() - 9);
        return date;
    }
    return;
};